import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ViewChild, ElementRef, AfterViewInit, AfterContentInit, AfterContentChecked } from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { ReceiptService } from '../../../../services/receipt.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'receipts-shippment-items',
  templateUrl: './shippment-items.component.html',
  styleUrls: ['./shippment-items.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({
        opacity: 1,
        display: 'block'
      })),
      state('closed', style({

        opacity: 0,
        display: 'none'

      })),
      transition('open => closed', [
        animate('0.5s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),
  ]
})
export class ShippmentItemsComponent implements OnInit {


  @Input() enableChange: boolean
  @Input() shipmentItem: any;
  @Output() shipmentItemObject = new EventEmitter();
  @Input() prodctgroup;
  @Output() changeRequest = new EventEmitter();
  @Input() changing: boolean;
  validationMessage: string = '';
  BranchWeightUnit: any;

  shipmentItems: any[] = [{
    chargeWeight: 0, height: 0, length: 0, NoPieces: 1, volWeight: 0, weight: 0, width: 0, weights: {
      chargeWeight: 0,
      volWeight: 0,
    }
  }];
  isOpen: boolean = true;
  ngOnChanges(changes: SimpleChanges) {
    if (changes['changing'] != undefined) {
      var change = changes['changing'].currentValue
      if (change == true) {
        this.isOpen = change;
        this.shipmentItems = [];
        this.disabled = true;
        this.shipmentItems.push({
          volWeight: 0, chargeWeight: 0, height: 0, length: 0, NoPieces: 1, weight: 0, width: 0, weights: {
            chargeWeight: 0,
            volWeight: 0,
          }
        })
      }
    }
  }

  constructor(private receiptService: ReceiptService,private translate: TranslateService) {
    this.BranchWeightUnit = JSON.parse(sessionStorage.getItem("company")).BranchCompanyDefaultWeightUnit;
  }
  addNewShipmentItem() {
    this.disabled = true;
    this.shipmentItems.push({
      volWeight: 0, chargeWeight: 0, height: 0, length: 0, NoPieces: 1, weight: 0, width: 0, weights: {
        chargeWeight: 0,
        volWeight: 0,
      }
    })
  }

  calculate(item, index) {
    
    this.validationMessage = '';
    var requestBody = {
      NumberOfPieces: item.NoPieces == undefined || item.NoPieces == 0 ? 1 : item.NoPieces,
      Dimensions: {
        Height: item.height == undefined ? 0 : item.height,
        Width: item.width == undefined ? 0 : item.width,
        Length: item.length == undefined ? 0 : item.length
      },
      GrossWeight: {
        Value: item.weight == undefined ? 0 : item.weight,
        Unit: 'kg'
      }
    }

    if (item.weight != undefined && item.weight != 0) {
      this.disabled = true;
      this.receiptService.calculateItemChargeableWeight(this.prodctgroup, requestBody, (res) => {
        this.shipmentItems[index].item = {
          NumberOfPieces: res.NumberOfPieces,
          Dimensions: res.Dimensions,
          GrossWeight: res.GrossWeight,
          VolumetricWeight: res.VolumetricWeight,
          ChargeableWeight: res.ChargeableWeight
        }

        this.shipmentItems[index].weight = res.GrossWeight.Value;
        this.shipmentItems[index].height = res.Dimensions.Height;
        this.shipmentItems[index].length = res.Dimensions.Length;
        this.shipmentItems[index].width = res.Dimensions.Width;
        this.shipmentItems[index].NoPieces = res.NumberOfPieces;
        this.shipmentItems[index].volWeight = res.VolumetricWeight.Value + res.VolumetricWeight.Unit;
        this.shipmentItems[index].weights.volWeight = res.VolumetricWeight.Value;
        this.shipmentItems[index].chargeWeight = res.ChargeableWeight.Value + res.ChargeableWeight.Unit
        this.shipmentItems[index].weights.chargeWeight = res.ChargeableWeight.Value
        this.disabled = false;
      }, (err) => { });
    }
  }
  disabled = true;
  checkNoOfPecies(index) {
    if (this.shipmentItems[index].NoPieces <= 0) {
      this.shipmentItems[index].NoPieces = 1
    }
  }
  deleteShipment(i) {
    this.shipmentItems.splice(i, 1);
  }

  editShipment(index) {
    this.shipmentItems[index].volWeight = '';
    this.shipmentItems[index].chargeWeight = '';

    if (this.validationMessage !== '')
      this.disabled = true;

  }

  getTotalWeights() {
    var volWeights = 0;
    var chargeWeights = 0;
    this.shipmentItems.forEach((item, i) => {
      volWeights += item.weights.volWeight;
      chargeWeights += item.weights.chargeWeight;
    });
    if (this.shipmentItems.length > 0) {
      return {
        volWeights: this.fixDecimals(volWeights),
        chargeWeights: this.fixDecimals(chargeWeights)
      }
    }
    else {
      return {
        volWeights: this.fixDecimals(0),
        chargeWeights: this.fixDecimals(0)
      }
    }
  }

  fixDecimals(value: any = 0) {
    if (value != 0) {
      value = parseFloat(value).toFixed(2);
      return value;
    }
    else {
      return 0;
    }
  }

  change() {
    this.isOpen = !this.isOpen;
    if (this.isOpen)
      this.changeRequest.emit(true);
  }

  getShipments() {
   
    var valid = true;
    if (this.shipmentItems.length > 0) {
      this.shipmentItems.forEach((x) => {
        if (x.weight == 0 || x.weight == undefined || x.weight == null) {
          valid = false;
          this.validationMessage = `<i class="unvalid armx - icon armx-cancel"></i> ${this.translate.instant('pages.createReceiptPage.errorMsgs.shipmentWeightValidationMsg')}`;
        }
      });
      if (valid) {
        this.shipmentItemObject.emit({ shipmentItems: this.shipmentItems, ChargeableWeight: this.getTotalWeights().chargeWeights })
        this.isOpen = !this.isOpen;
        this.validationMessage = '';
      }
    }
    else {
      this.validationMessage = `<i class="unvalid armx - icon armx-cancel"></i>${this.translate.instant('pages.createReceiptPage.errorMsgs.minShipmentItem')}`;
    }
  }

  ngOnInit() {

  }
}
